import request from '@/util/request';
import qs from 'qs';

// 分页
export const getList = (params, options) =>
request.get('/api/v4ward/assess/standard/page', Object.assign({}, options, { params }));

// 详情
export const getDetail = (params, options) =>
request.get('/api/v4ward/assess/standard/detail', Object.assign({}, options, { params }))

// 新增/编辑考核标准
export const submitAssess = (params, options) =>
request.post('/api/v4ward/assess/standard/submit', params,options)
// 删除
export const removeAssess = (params, options) =>
request.post('/api/v4ward/assess/standard/remove', qs.stringify(params),options);

// 停用
export const stopAssess = (params, options) =>
request.post('/api/v4ward/assess/standard/stop', qs.stringify(params),options);
